module.exports = __webpack_public_path__ + "img/lpn-service.dec986a8.jpg";